// removed by extract-text-webpack-plugin
module.exports = {"inventoryRecordCard":"_1gADX","hoverOverlay":"_-t__G","photo":"_3oObL","details":"_39ZHi","name":"_2GcSI","price":"qtLpr","discount":"_2NMIA","strikethrough":"_38TBu","hasInBag":"_1Ihsr","buyButton":"giFRd","quantity":"_3F-_I","quantitySubtext":"_3znkJ","quantityButtons":"_1hJUR","shake":"_2mMTX","decrementQuantityButton":"Gtlwb","incrementQuantityButton":"_3edBq"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordCard/index.sass
// module id = 1478
// module chunks = 1